/** @jsxImportSource @emotion/react */
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CircularProgress, Grid } from '@mui/material';
import { useStyles } from './MainLoader.styles';
import { cn } from '../../utils';

interface MainLoaderProps {
  show?: boolean;
  block?: boolean;
  fullScreen?: boolean;
  fullContent?: boolean;
  fillContainer?: boolean;
}

export function MainLoader({
  show = true,
  block,
  fullScreen,
  fillContainer,
  fullContent,
}: MainLoaderProps): React.ReactElement {
  const nodeRef = React.useRef(null);
  const styles = useStyles();

  return (
    <TransitionGroup css={styles} exit>
      {show ? (
        <CSSTransition
          nodeRef={nodeRef}
          key="transition-wrapper"
          classNames="transition-wrapper"
          timeout={100}
        >
          <div className="loader-wrapper" ref={nodeRef}>
            <div
              className={cn('loader', {
                overlay: !block,
                'full-screen': fullScreen,
                'full-content': fullContent,
                'fill-container': fillContainer,
              })}
            >
              <Grid className="grid" container>
                <Grid className="content" item md={12} lg={12}>
                  <CircularProgress color="inherit" />
                </Grid>
              </Grid>
            </div>
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
}
